'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Logo = function Logo(props) {
  var type = props.type,
      color = props.color,
      text = props.text,
      rest = _objectWithoutProperties(props, ['type', 'color', 'text']);

  var classes = (0, _classnames2.default)('pypl-logo', 'pypl-logo--' + type, 'pypl-logo--' + color, props.className);

  return _react2.default.createElement(
    'a',
    _extends({}, rest, { className: classes }),
    text
  );
};

Logo.propTypes = {
  text: _propTypes2.default.string.isRequired,
  href: _propTypes2.default.string.isRequired,
  color: _propTypes2.default.oneOf(['full-color', 'white', 'black-white']),
  type: _propTypes2.default.oneOf(['full-text', 'monogram', 'monogram-text']),
  className: _propTypes2.default.string
};

Logo.defaultProps = {
  color: 'full-color',
  type: 'full-text',
  className: ''
};

exports.default = Logo;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/logo/jsx/Logo.js
// module id = 661
// module chunks = 4